import { Lightbox } from "@msuite/ui/lightbox";
import type { PropsWithChildren } from "react";
import { useFilesWithAnnotations } from "@/hooks/use-files-with-annotations";
import { AnnotatedLightboxContext } from "./annotated-lightbox-context";

/** Props Interface */
interface AnnotatedLightboxProviderProps extends PropsWithChildren {
	itemHeight: string;
	fileIds: string[];
}

export function AnnotatedLightboxProvider({
	children,
	itemHeight,
	fileIds,
}: AnnotatedLightboxProviderProps) {
	/** Query */
	const { annotatedFileIds } = useFilesWithAnnotations(fileIds);

	/** Render */
	return (
		<AnnotatedLightboxContext.Provider value={{ annotatedFileIds }}>
			<Lightbox.Provider itemHeight={itemHeight}>{children}</Lightbox.Provider>
		</AnnotatedLightboxContext.Provider>
	);
}
